import React from 'react'
import { useLocalSearchParams } from 'expo-router'
import { LoungeJoinScreen } from '@/screens/lounges/LoungeJoinScreen'

export default function LoungeJoinRoute() {
  const { code } = useLocalSearchParams<{ code?: string }>()
  // A new link while this screen is open must start over: the code and auto-join state are per-mount.
  return <LoungeJoinScreen key={code ?? ''} />
}
